import { render, staticRenderFns } from "./aging.vue?vue&type=template&id=d5fd9836&"
import script from "./aging.vue?vue&type=script&lang=js&"
export * from "./aging.vue?vue&type=script&lang=js&"
import style0 from "./aging.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports